export default __webpack_public_path__ + "b7d34aa26af651f63bf6dd6877782f5c.svg";